module.exports = __webpack_public_path__ + "chalice.a87f74.svg";